import { useQuery } from "@tanstack/react-query";
import { getEntityMetaData } from "../api/real-cookie-banner.js";
import { useStores } from "../store/root.js";
import { QueryKeys } from "../util/query-keys.js";
/**
 * Hook to fetch metadata for a specific entity.
 * @param entity The name of the entity to fetch metadata for.
 * @returns A query object containing the entity metadata and loading state.
 */ function useEntityMetadata(entity) {
    const { rcbAuthenticationStore } = useStores();
    const entityMetadataQuery = useQuery(QueryKeys.getEntityMetadata(entity), ({ signal })=>{
        return getEntityMetaData({
            signal,
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                entity
            }
        });
    }, {
        staleTime: 1000 * 60 * 60 * 24,
        enabled: !!entity
    });
    return entityMetadataQuery;
}
export { useEntityMetadata };
